/**
 * @file 注册百度地图 App 端能力对象
 * @author wangjuntao <wangjuntao@baidu.com>
 */
import { nativeRegister } from '../index';
import is from '../bdmap/is';
import loadJS from 'scriptjs';
nativeRegister('bdmap', {
    is,
    load(callback) {
        if (!window.yymap) {
            loadJS('//webmap0.bdimg.com/yyfm/publish/js/yymap.min.662429d214dc6d4c83ae163c01084d75.js', function () {
                loadNativeBdmap(callback);
            });
        }
        else {
            loadNativeBdmap(callback);
        }
    }
});
function loadNativeBdmap(callback) {
    import(/* webpackChunkName: "native_bdmap" */ '../bdmap/index')
        .then(function ({ invoker: native }) {
        callback(native);
    });
}
//# sourceMappingURL=bdmap.js.map